import Cookies from 'js-cookie';
import { callAPI } from '..';
import { apiPath } from '..';
import { getCookieToken } from '..';

//發送簡訊
const callSendMobileAuth = async () => {

    try {
        const token = await getCookieToken();
        let headers = { 'token': token };

        const url = apiPath.GET_URL_SENDMOBILEAUTH;
        const method = 'GET';
        const response = await callAPI({ method, url, headers });
        const httpCode = response.status || -1;

        // 檢查 HTTP 狀態碼和回應數據的狀態
        if (httpCode === 200) {

            let payload = null;

            // 檢查是否為JSON Object;
            if (typeof response.data === 'string') {
                payload = JSON.parse(response.data);
            } else {
                payload = response.data;
            }

            console.log(payload)

            if (payload) {
                return payload;
            } else {
                return null; // 返回 null 表示失敗
            }
        } else if (httpCode !== -1) {
            // 處理其他錯誤
            alert(`網站遇到錯誤 - HTTP 狀態碼: ${httpCode}`);
            return null; // 返回 null 表示http發生錯誤
        } else {
            console.error('API 未執行:', url);
            return null; // 返回 null 表示API執行失敗
        }

    } catch (error) {
        console.error('Error :', error);
        return null; // 返回 null 表示API執行失敗
    }
};

//驗證簡訊
const callMobileAuth = async (code) => {

    try {
        const token = await getCookieToken();
        let headers = { 'token': token };
        let data = { 'code': code };

        const url = apiPath.GET_URL_MOBILEAUTH;
        const method = 'POST';
        const response = await callAPI({ method, url, headers, data });
        const httpCode = response.status || -1;

        // 檢查 HTTP 狀態碼和回應數據的狀態
        if (httpCode === 200) {

            let payload = null;

            // 檢查是否為JSON Object;
            if (typeof response.data === 'string') {
                payload = JSON.parse(response.data);
            } else {
                payload = response.data;
            }

            console.log(payload)

            if (payload) {
                return payload;
            } else {
                return null; // 返回 null 表示失敗
            }
        } else if (httpCode !== -1) {
            // 處理其他錯誤
            alert(`網站遇到錯誤 - HTTP 狀態碼: ${httpCode}`);
            return null; // 返回 null 表示http發生錯誤
        } else {
            console.error('API 未執行:', url);
            return null; // 返回 null 表示API執行失敗
        }

    } catch (error) {
        console.error('Error :', error);
        return null; // 返回 null 表示API執行失敗
    }
};

export { callSendMobileAuth, callMobileAuth }